import { useUnresolvedIncidents } from '@cobliteam/hooks/src/useEntity/useStatusPage';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { lazy } from '@cobliteam/lazy-with-retries';
import { Suspense } from 'react';

// O AppSidebar monta em toda página autenticada: o popover (Base UI) só baixa quando há incidente aberto.
const IncidentsPopover = lazy(() => import('./IncidentsPopover'));

const Incidents = () => {
  const featureFlag = useFeatureFlags();
  const {
    data: incidentsData,
    isLoading,
    error,
  } = useUnresolvedIncidents({
    enabled: featureFlag.sidebarIncidents,
  });

  if (!featureFlag.sidebarIncidents) return null;

  const hasIncidents = incidentsData?.incidents && incidentsData.incidents.length > 0;
  if (!hasIncidents) return null;

  return (
    <Suspense fallback={null}>
      <IncidentsPopover incidentsData={incidentsData} isLoading={isLoading} error={error} />
    </Suspense>
  );
};

export default Incidents;
